/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/semi */

import { DeviceMeta } from "./models/deviceMeta";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, NgZone } from "@angular/core";
import { User } from "./models/user";
import { Storage } from "@ionic/storage";
import { Car } from "./models/car.entity";
import { Device } from "./models/device";

// Import the wrapper class directly
//import { BleClient, numberToUUID } from '@capacitor-community/bluetooth-le';
import { Wifi } from "./models/wifi";
import { AlertButton, AlertController, Platform } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { CarDTO } from "./models/DTO/carDTO";

import { Base64 } from "@ionic-native/base64/ngx";

import { Base } from "./models/base";
import { BleClient, BleDevice, RequestBleDeviceOptions, ScanResult } from "@capacitor-community/bluetooth-le";
import { BleHelper } from "./models/bleHelper";
import { DevicelistPage } from "./devicelist/devicelist.page";

import { environment } from "../environments/environment";
import { CarHistoryDTO } from "./models/DTO/carHistoryDTO";
import { UserDTO } from "./models/DTO/userDTO";
import { Datapackage } from "./models/datapackage";
import { da } from "date-fns/locale";
import { WifiInfo } from "./models/WifiInfo";
import { Wifis } from "./models/wifis_";

@Injectable({
  providedIn: "root",
})
export class DataService {
  public static runConnectedScan: boolean;

  public static imagewidth = 300;
  public static imagequality = 80;

  carList: Car[] = [];

  carDirtyFlag: boolean;

  private scanTimeout?: ReturnType<typeof setTimeout>;
  private bluetoothAlertOpen = false;

  // Constants
  // eslint-disable-next-line @typescript-eslint/naming-convention
  BROWSER = "browser";
  // eslint-disable-next-line @typescript-eslint/naming-convention
  APP = "app";

  //mode: string = this.BROWSER
  mode: string = this.APP;

  // Having a global log
  log = "-log started-";

  // The data managed by the dataService
  devices: Device[] = [];
  devicecache: Device[] = [];

  deviceMetas: DeviceMeta[] = []; // Device-Object im Backend
  currentCar: Car = new Car();

  // BATTERY-GUARD stuff
  PREFIX = "hbg_";
  currentDevice: Device;
  connectedDevices: string[] = [];
  jwt: string;

  dirty: boolean = false; // Reload Data from backend

  _page = "dataService";
  _whoAmI = this._page;

  // eslint-disable-next-line max-len
  constructor(
    private base64: Base64,
    public ngZone: NgZone,
    public platform: Platform,
    public storage: Storage,
    private httpClient: HttpClient,
    private alertController: AlertController,
    private translate: TranslateService,
  ) {
    //this.listHootsDevices()
    //Base.console('info', '', this, 'constructor@DataService')
    DataService.runConnectedScan = true;
  }

  purgeStorage() {
    this.storage.clear();
  }

  /**
   *
   * @param car Assignment Car <-> Device
   * @param device
   * @param datapackage
   */
  async assignCarToDevice(car: Car, device: Device, datapackage: Datapackage) {
    Base.log("[" + this._page + "] ## AssignCarToDevice " + car.id + " " + device.id);
    this.installDeviceCall(car.id, device.id).subscribe((res) => {
      car.installedDeviceId = device.id;
      device.installedIn = car.id;
      datapackage.car = car;

      this.set("device", device);
      this.set("device" + device.id, device);

      this.getUser().then((user) => {
        Base.log("[" + this._page + "] write datapackage");
        Base.log(datapackage.toString());
        this.set("datapackage" + user.email, datapackage);
      });
    });
  }

  setOfflineMode(email: string, mode: boolean): Promise<void> {
    Base.log("[" + this._page + "] ##DS## setOfflineMode to " + mode);

    return this.get("datapackage" + email).then((dp) => {
      Base.log("[" + this._page + "] ##DS## datapackage read");

      if (dp !== null && dp !== undefined) {
        dp.offline = mode;
        Base.log("[" + this._page + "] ##DS## setOfflineMode done");
        return this.set("datapackage", dp);
      } else {
        Base.log("[" + this._page + "] ##DS## dp undefined or null");
        return new Datapackage();
      }
    });
  }

  storagedump() {
    this.storage.keys().then((key) => {
      console.log(key);
    });
  }

  // Check the status of the device
  // ble: isEnabled
  //      isConnected
  public async status() {
    //Base.console('info', '', this, 'status@DataService')
    Base.log("[" + this._page + "] ##DS## status");
    const temp = [];

    if (DataService.runConnectedScan === true) {
      return await BleClient.getConnectedDevices([BleHelper.BATTERY_SERVICE, BleHelper.WIFI_SERVICE]).then(
        (devices) => {
          devices.forEach((device) => {
            temp.push(device.name);
          });
          this.connectedDevices = temp;
          DevicelistPage.connectedDevices = temp;
          return temp;
        },
      );
    }
  }

  isDevice(): boolean {
    let veto = false;

    //Base.console('info', '--=====Check platforms======--', this, 'isDevice1@DataService')
    const mobiles = [];
    mobiles.push("android");
    mobiles.push("ios");
    mobiles.push("ipad");

    //["android", 'ios', 'ipad', 'iphone', 'mobile', 'phablet', 'pwa', 'tablet']
    mobiles.forEach((platform) => {
      //Base.console('info', platform + ' > ' + this.platform.is(platform), this, 'isDevice2@DataService')
      if (this.platform.is(platform)) {
        Base.log("[" + this._page + "] PLATFORM found: " + platform);
        veto = true;
      }
    });
    //Base.console('info', '--===== is mobile: ' + veto + ' ======--', this, 'isDevice3@DataService')
    return veto;
  }

  isBrowserMode() {
    return this.mode === this.BROWSER;
  }

  setUser(user: User): Promise<any> {
    return this.storage.set("user", user).then((_) => {
      return this.storage.set("user" + user.email, user);
    });
  }

  logIn() {
    return this.getUser();
  }

  storeImage(key, value) {
    return this.storage.set("image" + key, value);
  }

  getImage(key) {
    return this.storage.get("image" + key);
  }

  set(key, value) {
    let docu = new String(value);
    if (docu.length > 25) {
      docu = docu.substring(0, 20);
    }
    Base.log("[" + this._page + "] [ds] WRITTEN " + key + " with " + docu);
    return this.storage.set(key, value);
  }

  get(key) {
    Base.log("[" + this._page + "] [ds] get for " + key);
    return this.storage.get(key);
  }

  del(key) {
    return this.storage.remove(key);
  }

  registereddevices() {
    Base.log("[" + this._page + "] ##DS## registereddevices");
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
      }),
    };
    return this.httpClient.get(environment.poolData.Backend + "v1/devices", httpOptions);
  }

  getDevice(deviceId) {
    Base.log("[" + this._page + "] ##DS## getDevice");

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
      }),
    };
    return this.httpClient.get(environment.poolData.Backend + "v1/devices/" + deviceId, httpOptions);
  }

  getInstalledInForDevice(deviceName): any {
    let device: any;
    this.registereddevices().forEach((dev) => {
      if (dev["label"] === deviceName) {
        device = dev;
      }
    });
    return device;
  }

  async scan() {
    Base.log("[" + this._page + "] ##DS## setOfflineMode");
    if (this.isDevice()) {
      try {
        await BleClient.initialize({ androidNeverForLocation: true });

        await this.stopScanning();

        await BleClient.requestLEScan(
          {
            //services: [BleHelper.WIFI_SERVICE], //[HOOTS_DEVICES],
            namePrefix: "hbg_",
          },
          (result) => {
            //Base.console('info', 'received new scan result ' + result, this);
            if (this.devices.filter((e) => e.label === result.localName).length > 0) {
              //Base.console('info', result.localName + ' already present', this)
            } else {
              //if (result.localName.startsWith(this.PREFIX)) {
              if (result.localName.length > 0) {
                this.devices.push(new Device(result.device.deviceId, "", result.localName, WifiInfo.factory(), "", ""));
              }
              //Base.console('info', result.localName + ' added', this)
              // }
            }
          },
        );
      } catch (error) {
        console.error(error);
      }
    } else {
      //Base.console('info', 'Only on phsical device and bt enabled', this)
    }
  }

  async startScanning(
    options: RequestBleDeviceOptions,
    onResult: (result: ScanResult) => void,
    timeoutMs: number,
    onEnd?: () => void,
  ) {
    await this.stopScanning();
    if (!(await this.isBluetoothAvailable())) {
      this.showBluetoothDisabledAlert();
      onEnd?.();
      return;
    }
    await BleClient.requestLEScan(options, onResult);
    this.scanTimeout = setTimeout(async () => {
      await this.stopScanning();
      onEnd?.();
    }, timeoutMs);
  }

  private async isBluetoothAvailable(): Promise<boolean> {
    if (!this.isDevice()) {
      return true;
    }
    try {
      return await BleClient.isEnabled();
    } catch {
      // Android rejects when initialize never succeeded, e.g. Bluetooth permission denied
      return false;
    }
  }

  private async showBluetoothDisabledAlert() {
    if (this.bluetoothAlertOpen) {
      return;
    }
    this.bluetoothAlertOpen = true;

    const buttons: AlertButton[] = this.platform.is("android")
      ? [
          { text: this.translate.instant("cancel"), role: "cancel" },
          {
            text: this.translate.instant("bluetooth.disabled.enable"),
            handler: () => {
              BleClient.requestEnable().catch(() => undefined);
            },
          },
        ]
      : [{ text: this.translate.instant("ok"), role: "cancel" }];

    const alert = await this.alertController.create({
      header: this.translate.instant("bluetooth.disabled.title"),
      message: this.translate.instant("bluetooth.disabled.message"),
      buttons,
    });
    alert.onDidDismiss().then(() => (this.bluetoothAlertOpen = false));
    await alert.present();
  }

  async stopScanning() {
    // Pending timeout belongs to the scan being stopped; letting it fire would kill the next scan
    clearTimeout(this.scanTimeout);
    this.scanTimeout = undefined;
    if (this.isDevice()) {
      await BleClient.stopLEScan();
    }
  }

  async getUser() {
    Base.log("[" + this._page + "] ##DS## getUser 1");
    let user;
    try {
      user = await this.storage.get("user").then((innerUser) => {
        if (innerUser === null || innerUser === undefined) {
          user = new User();
          user.firstname = "Max";
          user.lastname = "Mustermann";
          this.setUser(user);
        }
        //this.downloadUserImage()
        return innerUser;
      });
    } catch (exc) {
      return undefined;
    }
    return user;
  }

  async getDevices() {
    Base.log("[" + this._page + "] ##DS## setOfflineMode");
    return this.scan().then((devices) => {
      if (devices === undefined) {
        //Base.console('info', 'New devices created while getting from storage', this)
        return [];
      }
      return this.devices;
    });
  }

  onDisconnect(devId) {
    Base.log("[" + this._page + "] ##DS## setOfflineMode");
    //Base.console('info', 'disconnect', this)
    //Base.console('method', 'Dataservice: DisconnectFromBTDevice', this);

    setTimeout(async () => {
      //Base.console('info', '***********************************', this)

      //Base.console('info', 'Disconnect from ' + devId, this)
      BleClient.disconnect(devId).then((result) => {
        //Base.console('info', 'Disconnected:', this)
        //Base.console('info', result, this);

        this.stopScanning();
      });

      this.stopScanning();
      //Base.console('info', '***********************************', this)
    }, 10);
  }

  /**
   * Get all cars of my account
   * @returns
   */
  getMyCars() {
    Base.log("[" + this._page + "] ##DS## setOfflineMode");
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
      }),
    };

    //Base.console('info', '---GET FLEET---')
    //Base.console('info', environment.poolData.Backend + 'v1/vehicles')
    //Base.console('info', httpOptions)
    //Base.console('info', '---/GF---')

    return this.httpClient.get(environment.poolData.Backend + "v1/vehicles", httpOptions);
  }

  getFleet(callback) {
    // // Base.log('[' + this._page + '] Fleet')
    const defaultCars: Car[] = [];

    this.getFleetFromBackend().subscribe((fleet) => {
      const cars = JSON.parse(JSON.stringify(fleet));
      cars.forEach((element) => {
        const car = new Car();
        car.setDataFromDTO(element);

        car.image = this.downloadCarImage(car, true);
        defaultCars.push(car);
      });
      callback.fleetLoaded(defaultCars);
    });
  }

  /**
   *
   * @returns Retrieve the fleet (Cars)
   */
  getFleetFromBackend() {
    Base.log("[" + this._page + "] ##DS## getFleetFromBackend (http)");
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
      }),
    };
    return this.httpClient.get(environment.poolData.Backend + "v1/vehicles", httpOptions);
  }

  downloadCarImage(car: Car, fromBackend: boolean): any {
    if (fromBackend === true) {
      const baseUrl = environment.poolData.Backend + "v1/vehicles/" + car.id + "/image";
      const headers = new HttpHeaders().set("Authorization", "Bearer " + this.jwt);
      this.httpClient.get(baseUrl, { headers, responseType: "blob" as "json" }).subscribe({
        next: (response: any) => {
          // Base.log(response)
          //let dataType = response.type;
          car.image = response;

          return this.setImage(car);
        },
        error: (err) => {
          Base.log("[" + this._page + "] ##DS## No image");
        },
      });
    } else {
      this.get(car.id).then((image) => {
        car.image = image;

        return this.setImage(car);
      });
    }
  }

  getUserAccount(update): any {
    Base.log("[" + this._page + "] ##DS## getUserAccount (http)");
    const baseUrl = environment.poolData.Backend + "v1/account";
    const headers = new HttpHeaders().set("Authorization", "Bearer " + this.jwt);

    // Base.log("[" + this._page + "] ##DS## getUserAccount")
    return this.httpClient.get(baseUrl, { headers });
  }

  downloadUserImage(): any {
    const baseUrl = environment.poolData.Backend + "v1/account/image";
    const headers = new HttpHeaders().set("Authorization", "Bearer " + this.jwt);

    return this.httpClient.get(baseUrl, { headers, responseType: "blob" as "json" }).subscribe({
      next: (response: any) => {
        this.getUser().then((u) => {
          // // Base.log(u)
          u.image = response;
          // // Base.log(u)
          this.setUserImage(u);
          this.setUser(u);

          //.refreshUserImages()
        });
      },
      error: (err) => {
        console.error(err.error);
      },
    });
  }

  loadUserImage() {
    const baseUrl = environment.poolData.Backend + "v1/account/image";
    const headers = new HttpHeaders().set("Authorization", "Bearer " + this.jwt);
    return this.httpClient.get(baseUrl, { headers, responseType: "blob" as "json" });
  }

  getImageData(data: Blob) {
    var reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onloadend = () => {
      return reader.result;
    };
  }

  setImage(car) {
    if (car.image === null || car.image === undefined || car.image === "") {
      return "./assets/noimage.png";
    } else {
      var reader = new FileReader();
      reader.readAsDataURL(car.image);
      reader.onloadend = () => {
        //car.imageBase64String = reader.result;
        car.image = reader.result;
        this.set(car.id, car.image);
      };

      return car.imageBase64String;
    }
  }

  /**
   *
   * @param key
   * @returns
   */
  getUserImage(key) {
    //Base.console('info', 'getUserImage ' + key)
    return this.getImage(key);
  }

  /**
   *
   * @param user
   * @returns
   */
  setUserImage(user) {
    //// // Base.log('[' + this._page + '] setUserImage')
    //// // Base.log(user)
    /*
    var reader = new FileReader();
    reader.readAsDataURL(user.image);
    reader.onloadend = () => {
      user.imageBase64String = reader.result;
      this.storage.set('userimage' + user.id, user.imageBase64String)
    }
    */
    if (user.image === undefined || user.image === "") {
      return "./assets/noimage.png";
    } else {
      var reader = new FileReader();
      reader.readAsDataURL(user.image);
      reader.onloadend = () => {
        user.imageBase64String = reader.result;
        this.storeImage(user.id, user.imageBase64String);
      };
      return user.imageBase64String;
    }
  }

  downloadFile(car: Car, httpOptionsImg: any): any {
    return this.httpClient.get(environment.poolData.Backend + "v1/vehicles/" + car.id + "/image", httpOptionsImg);
  }

  decorateImage(img) {
    if (img === undefined || img === null || img.length < 200) {
      //Base.console('info', 'show NO_IMAGE')
      img = "";
    } else {
      if (img !== undefined && img !== null && !img.startsWith("data")) {
        //Base.console('info', 'Decorize image-data')
        img = "base64," + img;
      }
    }

    return img;
  }

  connectToBTDevice(dev: Device) {
    Base.log("[" + this._page + "] ##DS## ConnectToBTDevice");
    //Base.console('method', 'Details: ConnectToBTDevice');

    if (this.isDevice()) {
      BleClient.initialize({ androidNeverForLocation: true }).then(() => {
        setTimeout(async () => {
          //Base.console('info', '***********************************')
          //Base.console('info', 'Connection to ' + dev.label + ' ')
          //Base.console('info', dev)
          BleClient.connect(dev.id).then((result) => {
            //Base.console('info', 'Connected:')
            //Base.console('info', '---trying services---');

            //Base.console('info', '---trying SENSOR_CHARACTERISTIC ---');
            BleClient.startNotifications(
              dev.id,
              BleHelper.BATTERY_SERVICE,
              BleHelper.SENSOR_CHARACTERISTIC,
              (value) => {
                //Base.console('info', '---got SENSOR_CHARACTERISTIC---');
                //Base.console('info', value);

                this.status();

                return value;
              },
            );
          });
          //Base.console('info', '***********************************')
        }, 1000);
      });
    } else {
      //Base.console('info', 'Only on phsical device and bt enabled')
    }
  }

  connectToBTDeviceForId(devId: string) {
    Base.log("[" + this._page + "] ##DS## ConnectToTBTDeviceForId");
    //Base.console('method', 'Details: ConnectToBTDevice');

    if (this.isDevice()) {
      BleClient.initialize({ androidNeverForLocation: true }).then(() => {
        setTimeout(async () => {
          //Base.console('info', '***********************************')
          //Base.console('info', 'Connection to ' + devId + ' ')
          //Base.console('info', devId)
          BleClient.connect(devId).then((result) => {
            //Base.console('info', 'Connected:')
            //Base.console('info', '---trying services---');

            //Base.console('info', '---trying SENSOR_CHARACTERISTIC ---');
            BleClient.startNotifications(devId, BleHelper.BATTERY_SERVICE, BleHelper.SENSOR_CHARACTERISTIC, (value) => {
              //Base.console('info', '---got SENSOR_CHARACTERISTIC---');
              //Base.console('info', value);

              return value;
            });
          });
          //Base.console('info', '***********************************')
        }, 2000);
      });
    } else {
      //Base.console('info', 'Only on physical device and bt enabled')
    }
  }

  getDevicelist(): any[] {
    Base.log("[" + this._page + "] ##DS## getDevicelist");
    const deviceList: any[] = [];

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
      }),
    };

    this.httpClient.get(environment.poolData.Backend + "v1/devices", httpOptions).subscribe(
      (result) => {
        Base.log("[" + this._page + "] Deviceliste vom Server");
        const devices = JSON.parse(JSON.stringify(result));
        Base.log(devices);

        devices.forEach((element) => {
          //Base.console('info', '=Result=')
          //Base.console('info', element);

          const deviceMeta = new DeviceMeta();
          deviceMeta.createdAt = element.createdAt;
          deviceMeta.id = element.id;
          deviceMeta.installedIn = element.installedIn;
          deviceMeta.lastSeenAt = element.lastSeenAt;
          deviceMeta.registeredTo = element.registeredTo;
          deviceMeta.updatedAt = element.updatedAt;
          deviceList.push(deviceMeta);
        });

        Base.log("[" + this._page + "] **deviceList from backend**");
        Base.log(deviceList);

        return deviceList;
      },
      (err) => {
        //Base.console('error', err.error)
      },
    );
    return deviceList;
  }

  getDevicelistShort() {
    Base.log("[" + this._page + "] ##DS## getDeviceListShort");
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
      }),
    };
    Base.log("[" + this._page + "] **deviceListShort from backend**");
    return this.httpClient.get(environment.poolData.Backend + "v1/devices", httpOptions);
  }

  getDevicesFromBackend() {
    Base.log("[" + this._page + "] ##DS## getDevicesFromBackend");
    let returner: Device;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
      }),
    };

    return this.httpClient.get(environment.poolData.Backend + "v1/devices", httpOptions);
  }

  getUserFromBackend() {
    Base.log("[" + this._page + "] ##DS## getUserFromBackend");
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
      }),
    };

    return this.httpClient.get(environment.poolData.Backend + "v1/account", httpOptions);
  }

  registerDevice(device: Device) {
    Base.log("[" + this._page + "] ##DS## registerDevice");
    //Base.console('info', 'register device:')
    //Base.console('info', device)

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
        "Content-Type": "application/json",
      }),
    };

    //const serialno = device.label.replace('hbg_', '')
    const registerurl = environment.poolData.Backend + "v1/devices/" + device.id + "/registrations";
    Base.log("[" + this._page + "] PUT " + registerurl);
    return this.httpClient.put<Device>(registerurl, "", httpOptions);
  }

  updateUser(user: User) {
    Base.log("[" + this._page + "] ##DS## updateUser");
    const userDto = new UserDTO();
    userDto.setDTOFromModel(user);

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
        "Content-Type": "application/json",
      }),
    };

    //const serialno = device.label.replace('hbg_', '')
    const updateurl = environment.poolData.Backend + "v1/account";
    // Base.log('[' + this._page + '] PUT ' + updateurl)
    // Base.log(JSON.stringify(userDto))
    return this.httpClient.put<User>(updateurl, JSON.stringify(userDto), httpOptions);
  }

  unregisterDevice(device: Device) {
    Base.log("[" + this._page + "] ##DS## unregisterDevice");
    //Base.console('info', 'unregister device:')
    //Base.console('info', device)

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
        "Content-Type": "application/json",
      }),
    };

    const unregisterurl = environment.poolData.Backend + "v1/devices/" + device.id + "/registrations";
    //Base.console('info', 'DELETE ' + unregisterurl)
    return this.httpClient.delete<Device>(unregisterurl, httpOptions);
  }

  uninstallDevice(serialno) {
    Base.log("[" + this._page + "] ##DS## uninstallDevice");
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
        "Content-Type": "application/json",
      }),
    };

    // eslint-disable-next-line max-len
    this.httpClient
      .delete<Device>(environment.poolData.Backend + "v1/devices/" + serialno + "/installations", httpOptions)
      .subscribe(
        (res) => {
          // // Base.log('[' + this._page + '] device removed from car (unassigned)')
          this.set("assigned", "");
        },
        (error) => {
          // Base.log("[" + this._page + "] ##DS## -----")
          // Base.log(error.error)
        },
      );
  }

  installDevice(carId: string, devicename: string) {
    Base.log("[" + this._page + "] ##DS## installDevice");
    // Base.log(carId + " " + devicename)
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
        "Content-Type": "application/json",
      }),
    };

    const serialno = devicename.replace("hbg_", "");

    // Base.log(environment.poolData.Backend + 'v1/devices/' + serialno + '/installations?vehicleId=' + carId)
    // eslint-disable-next-line max-len
    this.httpClient
      .put<Device>(
        environment.poolData.Backend + "v1/devices/" + serialno + "/installations?vehicleId=" + carId,
        "",
        httpOptions,
      )
      .subscribe(
        (res) => {
          Base.console("info", "device installed");
          // // Base.log('[' + this._page + '] device installed to car (assign)')
          this.set("assigned", serialno);
        },
        (error) => {
          // Base.log("[" + this._page + "] ##DS## -----")
          // Base.log(error.error)
        },
        //
      );
  }

  installDeviceCall(carId: string, devicename: string) {
    Base.log("[" + this._page + "] ##DS## installDeviceCall");
    // // Base.log(carId + " " + devicename)
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
        "Content-Type": "application/json",
      }),
    };

    const serialno = devicename.replace("hbg_", "");

    // eslint-disable-next-line max-len
    return this.httpClient.put<Device>(
      environment.poolData.Backend + "v1/devices/" + serialno + "/installations?vehicleId=" + carId,
      "",
      httpOptions,
    );
  }

  /**
   * read the number of provisioned wifis of this device
   * @param devicelabel Just the serial 050-00007, otherwise be stripped


   getWifiCnt(devicelabel: string): Promise<Wifis> {

   devicelabel = devicelabel.replace("hbg_", "")
   Base.log("[" + this._page + "]WifiCnt (get) ##DS##(storage) getWifiCnt " + devicelabel)

   return this.storage.get('wifiCnt' + devicelabel).then((result) => {

   Base.log("[" + this._page + "]WifiCnt (get) ##DS##(storage) getWifiCnt " + devicelabel)
   Base.log(result)
   if (result !== null && result !== undefined) {
   Base.log("[" + this._page + "]WifiCnt (get) ##DS##(storage) getWifiCnt " + devicelabel + " with " + result)
   return result
   } else {
   Base.log("[" + this._page + "]WifiCnt (get) ##DS##(storage) getWifiCnt " + devicelabel + " without value ")
   return 0
   }
   })
   }
   */

  /**
   * set the number of provisioned wifis of this device
   * @param devicelabel Just the serial 050-00007, otherwise be stripped
   * @param wifis        The wifis in class wifis

   async setWifiCnt(devicename: string, wifiCnts: number) {

   devicename = devicename.replace("hbg_", "")
   Base.log("[" + this._page + "]WifiCnt (set) ##DS## setWifiCnt for " + devicename + " to " + wifiCnts)

   await this.storage.set('wifiCnt' + devicename, wifiCnts).then((result) => {
   Base.log("[" + this._page + "]WifiCnt (set) ##DS## setWifiCnt set")

   })
   }
   */

  /**
   * read the current wifi of this device
   * @param devicelabel Just the serial 050-00007, otherwise be stripped
   */

  getWifiData(devicelabel: string): Promise<WifiInfo> {
    if (devicelabel!) {
      devicelabel = devicelabel.replace("hbg_", "");
      Base.log("[" + this._page + "]WifiData (get) ##DS##(storage) getWifiData " + devicelabel);

      return this.storage.get("WifiData" + devicelabel).then((result) => {
        Base.log("[" + this._page + "]WifiData (get) ##DS##(storage) getWifiData " + devicelabel);
        if (result !== null && result !== undefined && result.lastWifi !== undefined) {
          Base.log(
            "[" +
              this._page +
              "]WifiData (get) ##DS##(storage) getWifiData " +
              devicelabel +
              " with " +
              result.lastWifi +
              " " +
              result.count +
              " wifis",
          );
          return result;
        } else {
          Base.log("[" + this._page + "]WifiData (get) ##DS##(storage) getWifiData " + devicelabel + " without value ");
          return WifiInfo.factory();
        }
      });
    } else {
      return Promise.reject();
    }
  }

  /**
   * set the page-context wifi infos per device
   * @param devicelabel Just the serial 050-00007, otherwise be stripped
   * @param wifi        The wifi
   */
  async setWifiData(devicename: string, wifi: WifiInfo) {
    if (devicename!) {
      devicename = devicename.replace("hbg_", "");
      Base.log("[" + this._page + "]setWifiData (set) ##DS##");

      this.storage.set("WifiData" + devicename, wifi).then((result) => {
        Base.log(
          "[" +
            this._page +
            "]setWifiData for device " +
            devicename +
            " with " +
            wifi.count +
            " wifis, last " +
            wifi.lastWifi,
        );
      });
    }
  }

  /**
   * set the number of provisioned wifis of this device
   * @param devicelabel Just the serial 050-00007, otherwise be stripped
   * @param wifis        The wifis in class wifis
   */
  async modWifi(devicename: string) {
    if (devicename!) {
      devicename = devicename.replace("hbg_", "");
      Base.log("[" + this._page + "] ##DS## modWifi for " + devicename);
      this.storage.get("wifiState" + devicename).then((wifis) => {
        this.storage.set("wifiState" + devicename, wifis).then((result) => {
          // Base.log('[' + this._page + '] save wifistate for ' + devicelabel + ' to ' + wificnt)
        });
      });
    }
  }

  async delWifi(devicename: string, dataPackage: Datapackage) {
    if (devicename!) {
      devicename = devicename.replace("hbg_", "");
      Base.log("[" + this._page + "] ##DS## delWifi " + devicename);

      await this.storage.remove("wifiState" + devicename).then((result) => {
        Base.log("[" + this._page + "] WIPED THE WIFI " + devicename);

        dataPackage.devices.forEach((device) => {
          Base.log(device);
          Base.log("wifi" + device.id + "----" + devicename);

          if ("wifi" + device.id === devicename) {
            device.last.wifiSsid.status = "";
            device.last.wifiSsid.value = "";
            device.last = null;
            Base.log("[" + this._page + "] WIFI LAST DEL");
            Base.log(device);
          }
        });
        /*
              this.getUser().then((user) => {
                this.set("datapackage" + user.email, dataPackage)
              })
        */
        // Base.log('[' + this._page + '] save wifistate for ' + devicelabel + ' to ' + wificnt)
      });
    }
  }

  /*
    async saveWifi(devicename: string, wifiname) {
      Base.log("[" + this._page + "] ##DS## saveWifi")
      //Base.console('info', '<<-----------------<<')
      //Base.console('info', 'save wifi')
      //Base.console('info', devicename)

      await this.storage.set('device' + devicename, wifiname).then((result) => {
        //Base.console('info', 'save wifi result:')
        //Base.console('info', result)
      })
    }



    async loadWifi(devicename: string) {
      Base.log("[" + this._page + "] ##DS## loadWifi")
      //Base.console('info', '>>----------------->>')
      //Base.console('info', 'load wifi:')
      //Base.console('info', devicename)

      return await this.storage.get('device' + devicename).then((result) => {
        //Base.console('info', 'load wifi result:')
        //Base.console('info', result)
        return result
      })
    }
  */

  async saveFirmware(devicename: string, firmware) {
    //Base.console('info', '<<-----------------<<')
    //Base.console('info', 'save firmware')
    //Base.console('info', devicename + ' ' + firmware)

    await this.storage.set("firmware" + devicename, firmware).then((result) => {
      //Base.console('info', 'save firmware result:')
      //Base.console('info', result)
    });
  }

  async loadFirmware(devicename: string) {
    //Base.console('info', '>>----------------->>')
    //Base.console('info', 'load firmware for ' + devicename)
    //Base.console('info', devicename)

    return await this.storage.get("firmware" + devicename).then((result) => {
      //Base.console('info', 'load firmware result:')
      //Base.console('info', result)
      return result;
    });
  }

  saveCarImage(car: Car) {
    Base.log("[" + this._page + "] ##DS## saveCarImage");
    //Base.console('info', 'save car image:')
    //Base.console('info', car)

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
        "Content-Type": "image/png",
      }),
    };

    //Base.console('info', 'Send car-image')

    //Base.console('info', environment.poolData.Backend + 'v1/vehicles/' + car.id + '/image')

    return this.httpClient.put<CarDTO>(
      environment.poolData.Backend + "v1/vehicles/" + car.id + "/image",
      this.makeBlob(car.imageDataUrl),
      httpOptions,
    );
  }

  saveImageForCar(carId, imagedata) {
    Base.log("[" + this._page + "] IMAGEDATA");
    Base.log(imagedata);

    Base.log("[" + this._page + "] ##DS## saveImageFor Car");
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
        "Content-Type": "image/png",
      }),
    };
    return this.httpClient.put<CarDTO>(
      environment.poolData.Backend + "v1/vehicles/" + carId + "/image",
      this.makeBlob(imagedata),
      httpOptions,
    );
  }

  saveUserImage(image: any) {
    Base.log("[" + this._page + "] ##DS## SaveUserImage");
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
        "Content-Type": "image/png",
      }),
    };
    Base.log("[" + this._page + "] ##DS## SaveUserImage " + environment.poolData.Backend + "v1/account/image");
    return this.httpClient.put<any>(
      environment.poolData.Backend + "v1/account/image",
      this.makeBlob(image),
      httpOptions,
    );
  }

  makeBlob(dataURL) {
    if (dataURL !== undefined) {
      var BASE64_MARKER = ";base64,";
      if (dataURL.indexOf(BASE64_MARKER) == -1) {
        var parts = dataURL.split(",");
        var contentType = parts[0].split(":")[1];
        var raw = decodeURIComponent(parts[1]);
        return new Blob([raw], { type: contentType });
      }
      var parts = dataURL.split(BASE64_MARKER);
      var contentType = parts[0].split(":")[1];
      var raw = window.atob(parts[1]);
      var rawLength = raw.length;

      var uInt8Array = new Uint8Array(rawLength);

      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      return new Blob([uInt8Array], { type: contentType });
    }
  }

  saveCar(car: Car) {
    Base.log("[" + this._page + "] ##DS## saveCar");
    this.set("car" + car.id, car);

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
        "Content-Type": "application/json",
      }),
    };

    const carDto = new CarDTO();
    carDto.setDTOFromModel(car);

    return this.httpClient.put<CarDTO>(
      environment.poolData.Backend + "v1/vehicles/" + car.id,
      JSON.stringify(carDto),
      httpOptions,
    );
  }

  /**
   *
   * @param car Creates a car in the backend
   * @returns carId uuid
   */
  addCar(car: Car) {
    Base.log("[" + this._page + "] ##DS## addCar");
    // Should be added
    //Base.console('info', 'add car:')
    //Base.console('info', car)

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
        "Content-Type": "application/json",
      }),
    };

    //Base.console('info', '---Store car---')
    //Base.console('info', environment.poolData.Backend + 'v1/vehicles')
    //Base.console('info', httpOptions)
    //Base.console('info', '---/store car---')

    const carDto = new CarDTO();
    carDto.setDTOFromModel(car);

    return this.httpClient.post<CarDTO>(
      environment.poolData.Backend + "v1/vehicles",
      JSON.stringify(carDto),
      httpOptions,
    );
  }

  getCar(carId: string) {
    Base.log("[" + this._page + "] ##DS## getCar");
    // // Base.log('[' + this._page + '] Get car for ' + carId)
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
        "Content-Type": "application/json, text/plain, */*",
      }),
    };
    //Base.console('info', environment.poolData.Backend + 'v1/vehicles/' + carId)
    return this.httpClient.get<CarDTO>(environment.poolData.Backend + "v1/vehicles/" + carId, httpOptions);

    /*
    .subscribe((res) => {
      //Base.console('info', 'DataService: got car')
      //Base.console('info', res)
      return returnCar.setDataFromDTO(res)
    })
  */
  }

  getCarHistory(carId: string) {
    Base.log("[" + this._page + "] ##DS## getCarHistory");
    // Should be added
    //Base.console('info', 'DataService: get car range data with id ' + carId)

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
        "Content-Type": "application/json, text/plain, */*",
      }),
    };
    //Base.console('info', environment.poolData.Backend + 'v1/vehicles/' + carId + '/data/range')
    return this.httpClient.get<CarHistoryDTO>(
      environment.poolData.Backend + "v1/vehicles/" + carId + "/data/range",
      httpOptions,
    );

    /*
    .subscribe((res) => {
      //Base.console('info', 'DataService: got car')
      //Base.console('info', res)
      return returnCar.setDataFromDTO(res)
    })
  */
  }

  deleteCar(carId: string) {
    Base.log("[" + this._page + "] ##DS## deleteCar");
    // Should be added
    //Base.console('info', 'delete car:')
    //Base.console('info', carId)

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.jwt,
        "Content-Type": "application/json",
      }),
    };

    return this.httpClient.delete<CarDTO>(environment.poolData.Backend + "v1/vehicles/" + carId, httpOptions);
  }

  setFleet(cars: Car[]) {
    this.storage.set("cars", cars);
    //Base.console('info', cars.length + ' cars written')
  }

  setCurrentCar(car: Car) {
    this.currentCar = car;
  }

  getCurrentCar(): Car {
    return this.currentCar;
  }
}
